module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/graph-reports.22d532dc.svg";